import { Popover, Transition } from '@headlessui/react';
import { Fragment, ReactElement } from 'react';

import { NavigationLinks } from './NavigationLinks';
import config from '../config/index.json';

export const Header = (): ReactElement => {
    const { company } = config;
    const { name: companyName, logo } = company;

    return (
        <>
            <Popover>
                <div className='relative pt-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto'>
                    <nav
                        className='relative flex items-center justify-between sm:h-10 lg:justify-start'
                        aria-label='Global'
                    >
                        <div className='flex items-center flex-grow flex-shrink-0 lg:flex-grow-0'>
                            <div className='flex items-center justify-between w-full md:w-auto'>
                                <a href='/'>
                                    <span className='sr-only'>{companyName}</span>
                                    <img alt='logo' className='h-16 w-auto sm:h-16' src={logo} />
                                </a>
                                <div className='-mr-2 flex items-center md:hidden'>
                                    <Popover.Button
                                        className={'bg-background rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-secondary'}
                                    >
                                        <span className='sr-only'>{'Open main menu'}</span>
                                    </Popover.Button>
                                </div>
                            </div>
                        </div>
                        <NavigationLinks
                            containerClass={'hidden md:block md:ml-10 md:pr-4 md:space-x-8'}
                            linkClass={'font-medium text-gray-500 hover:text-gray-900'}
                        />
                    </nav>
                </div>

                <Transition
                    as={Fragment}
                    enter='duration-150 ease-out'
                    enterFrom='opacity-0 scale-95'
                    enterTo='opacity-100 scale-100'
                    leave='duration-100 ease-in'
                    leaveFrom='opacity-100 scale-100'
                    leaveTo='opacity-0 scale-95'
                >
                    <Popover.Panel
                        focus
                        className='absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden'
                    >
                        <div
                            className={'rounded-lg shadow-md bg-background ring-1 ring-black ring-opacity-5 overflow-hidden'}
                        >
                            <div className='px-5 pt-4 flex items-center justify-between'>
                                <div>
                                    <img className='h-8 w-auto' src={logo} alt='logo' />
                                </div>
                                <div className='-mr-2'>
                                    <Popover.Button
                                        className={'bg-background rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-secondary'}
                                    >
                                        <span className='sr-only'>{'Close main menu'}</span>
                                    </Popover.Button>
                                </div>
                            </div>
                            <NavigationLinks
                                containerClass={'px-2 pt-2 pb-3 space-y-1'}
                                linkClass={'block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50'}
                            />
                        </div>
                    </Popover.Panel>
                </Transition>
            </Popover>
        </>
    );
};
